import { stegaClean } from 'next-sanity';

export const stegaCleanValue = <T extends string>(value?: T | null) => {
	if (!value) {
		return undefined;
	}
	return stegaClean(value);
};
